import { Box, Button } from "@mui/material"
import { useOrdersContext } from "../../../context/subscription/orders/OrdersContext"
import { Link } from "react-router-dom"
import Loading from "../../../components/loader/Loading"

const ConfirmationForm = () => {
    const { setShowConfirmationForm, isLoading } = useOrdersContext()
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            width: { xs: "100%",md:"400px" }
        }}>
            <button className="btn btn-green" onClick={() => setShowConfirmationForm(true)} style={{ width: "70%" }}>
                {isLoading.payBill ? <Loading color="#fff" /> : "تایید نهایی"}
            </button>
            <Link to="/subscription" className="btn btn-red" style={{ width: "30%" }}>
                انصراف
            </Link>
        </Box>
    )
}

export default ConfirmationForm